import { ENV_CONFIG } from '@core/interfaces/configs';

export const gtmConfigFactory = (env: ENV_CONFIG) => {
  return window.location.href.indexOf('/checkout/') === -1 ? env.gtmPortalId : env.gtmCheckoutId;
};
